import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const s = useSite()?.data?.settings || {};
  const socials = [["facebook", Facebook], ["instagram", Instagram]].filter(([k]) => s[k]);
  return (
    <footer className="bg-[var(--ink)] text-white/90 grain" data-testid="site-footer">
      <div className="container-x py-14 lg:py-16 grid gap-10 lg:grid-cols-12 items-start">
        <div className="lg:col-span-6">
          <p className="font-display text-3xl sm:text-4xl font-extrabold text-white leading-[0.95]">Mais Saúde Mental,<br /><span className="text-[var(--sun)]">para Todos.</span></p>
        </div>
        <div className="lg:col-span-6 lg:justify-self-end self-center">
          {socials.length > 0 && <div className="flex gap-2">
            {socials.map(([k, Icon]) => (
              <a key={k} href={s[k]} target="_blank" rel="noreferrer" aria-label={k} className="h-11 w-11 grid place-items-center rounded-full border border-white/20 hover:bg-white/10" data-testid={`footer-social-${k}`}><Icon className="h-5 w-5" /></a>
            ))}
          </div>}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-white/60">
          <p>© 2026 AASPS</p>
          <ul className="flex flex-wrap gap-x-5 gap-y-2">
            <li><Link to="/privacidade" className="hover:text-white">Privacidade</Link></li>
            <li><Link to="/cookies" className="hover:text-white">Cookies</Link></li>
            <li><Link to="/informacoes#acessibilidade" className="hover:text-white">Acessibilidade</Link></li>
            <li><Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">Área reservada</Link></li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
